(function () {
  function initAccordions(root = document) {
    root.querySelectorAll("[data-accordion]").forEach((accordion) => {
      if (accordion.dataset.init === "true") return;
      accordion.dataset.init = "true";

      const items = accordion.querySelectorAll("[data-accordion-item]");

      accordion.addEventListener("click", (e) => {
        const trigger = e.target.closest("[data-accordion-trigger]");
        if (!trigger) return;

        const item = trigger.closest("[data-accordion-item]");
        if (!item) return;

        const isOpen = item.classList.contains("is-active");

        // close all
        items.forEach((i) => {
          i.classList.remove("is-active");
          const btn = i.querySelector("[data-accordion-trigger]");
          if (btn) btn.setAttribute("aria-expanded", "false");
        });

        // toggle current
        if (!isOpen) {
          item.classList.add("is-active");
          trigger.setAttribute("aria-expanded", "true");
        }
      });
    });
  }

  document.addEventListener("DOMContentLoaded", () => initAccordions());
  document.addEventListener("shopify:section:load", (e) => initAccordions(e.target));
})();
